import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { CarrierDialog } from 'src/modules/supply_chain/components/CarrierDialog'
import { skuit } from 'src/services/skuit'

import { CarrierListTable } from 'src/components/Table/list/Carrier'
import { ListPage } from 'src/components/Pages/ListPage'

export const CarrierListPage = () => {
  const paginator = useQueryPaginator('carrier-list', skuit.sc.carriers.list)

  const exportFields = [
    'created_on',
    'guid',
    'name',
    'scac_code',
    'carrier_type',
    'use_internal_tracking',
  ]

  return (
    <ListPage
      title='Carriers'
      paginator={paginator}
      dialogs={[{ title: 'New Carrier', Dialog: CarrierDialog }]}
    >
      <CarrierListTable
        paginator={paginator}
        fields={['name', 'scac', 'carrierType']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.carriers.export,
        }}
      />
    </ListPage>
  )
}
